import { inject, Injectable } from '@angular/core';
import { CheckInWidget } from '@com-delta-idp/mnx-capability-check-in-ui';
import { CheckInStaticAem } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { CheckInDropdownAdapterService } from './check-in-dropdown-adapter.service';

@Injectable({
  providedIn: 'root'
})
export class CheckInContentAdapterService {
  dropdownAdapter = inject(CheckInDropdownAdapterService);

  getContent(
    content: CheckInStaticAem,
    nameLengthConfig?: boolean
  ): CheckInWidget {
    const { checkInForm } = content;
    return {
      inputSelectedDropdownOption: this.dropdownAdapter.extractSelectOption(
        checkInForm.dropDownData,
        checkInForm.toolTipData
      ),
      dropDownCheckInOption: this.dropdownAdapter.getDropDownOptions(
        checkInForm.dropDownData,
        checkInForm.findYourTripByLabel
      ),
      checkInRedirectUrl: checkInForm.submitUrl,
      errors: {
        confirmationNumber: {
          invalid: checkInForm.errorMessages.confirmationNumber.invalid,
          required: checkInForm.errorMessages.confirmationNumber.required
        },
        creditCardNumber: {
          invalid: checkInForm.errorMessages.creditCardNumber.invalid,
          required: checkInForm.errorMessages.creditCardNumber.required
        },
        fromCity: {
          invalid: checkInForm.errorMessages.fromCity.invalid,
          required: checkInForm.errorMessages.fromCity.required
        },
        last_Name: {
          invalid: checkInForm.errorMessages.last_Name.invalid,
          required: checkInForm.errorMessages.last_Name.required
        },
        skymiles: {
          invalid: checkInForm.errorMessages.skymiles.invalid,
          required: checkInForm.errorMessages.skymiles.required
        },
        ticketNumber: {
          invalid: checkInForm.errorMessages.ticketNumber.invalid,
          required: checkInForm.errorMessages.ticketNumber.required
        }
      },
      labels: {
        lastNameLabel: checkInForm.lastName.label,
        fromAirportLabel: checkInForm.fromAirport.label,
        buttonLabel: checkInForm.search.label
      },
      accessibility: {
        lastNameAriaLabel: checkInForm.lastName.ariaLabel,
        fromAirportAriaLabel: checkInForm.fromAirport.ariaLabel,
        buttonAriaLabel: checkInForm.search.ariaLabel
      },
      alertText: {
        title: checkInForm.errorText.title,
        subtitle: checkInForm.errorText.subTitle
      },
      nameLengthConfig: nameLengthConfig
    };
  }
}
